// extracted by mini-css-extract-plugin
export default {"-large":"grid-email-signup-form-item-module__-large--DmCCx","signupFormGridItem":"grid-email-signup-form-item-module__signupFormGridItem--RPxIV"};